"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { TimerEngine } from "@/utils/settimeout";
import { EventEmitter } from "events";
const UUID = require("uuid");
class VerifyInputQuery {
  constructor() {
    this.code = 0;
    this.phone = "";
    this.params = {};
  }
}
class VerifyInputLock {
  constructor() {
    this.status = false;
    this.msg = "";
  }
}
export class VerifyInputController extends EventEmitter {
  constructor(url, code, phone) {
    super();
    this._verifyCodeSend = false;
    this._verifyCodeTimer = 90;
    this._verifyTimer = null;
    this._query = new VerifyInputQuery();
    this._lock = new VerifyInputLock();
    this._url = "";
    this._url = url;
    this._query.code = code;
    if (phone) {
      this._query.phone = phone;
    }
  }
  get query() {
    return this._query;
  }
  get lock() {
    return this._lock;
  }
  set url(url) {
    this._url = url;
  }
  get url() {
    return this._url;
  }
  get verifyCodeSend() {
    return this._verifyCodeSend;
  }
  get verifyCodeTimer() {
    return this._verifyCodeTimer;
  }
  checkTimer() {
    let _timer = parseInt(sessionStorage.getItem("verifyCodeTimer"));
    if (!isNaN(_timer)) {
      this.setTimer(_timer);
    }
  }
  setTimer(time = 90) {
    this._verifyTimer = new TimerEngine(() => __async(this, null, function* () {
      console.dir(this._verifyCodeTimer);
      this._verifyCodeTimer = this._verifyCodeTimer - 1;
      sessionStorage.setItem("verifyCodeTimer", this._verifyCodeTimer.toString());
      if (this._verifyCodeTimer <= 0) {
        this._verifyTimer.stop();
        this._verifyTimer = null;
        this._verifyCodeSend = false;
        this._verifyCodeTimer = 90;
      }
    }), 1e3);
    this._verifyCodeTimer = time;
    this._verifyCodeSend = true;
    this._verifyTimer.start();
  }
  clearTimer() {
    this._verifyCodeTimer = 0;
    sessionStorage.removeItem("verifyCodeTimer");
  }
}
let VerifyInput = class extends Vue {
  constructor() {
    super(...arguments);
    this.refresh_key = UUID.v4();
  }
  mounted() {
    this._controller.checkTimer();
  }
  getVerifyCode(time = 90) {
    return __async(this, null, function* () {
      try {
        if (this._controller.url === "" || this._controller.url === null || this._controller.url === void 0) {
          this.$message.error(this.$t("verifyinput.please_set"));
          return;
        }
        if (this._phone === "" || this._phone === null || this._phone === void 0) {
          this.$message.error(this.$t("verifyinput.mobile_phone_number_cannot_be_empty"));
          return;
        }
        if (this._controller.lock.status) {
          this.$message.error(this._controller.lock.msg);
          return;
        }
        const response = yield API.post(this._controller.url, __spreadValues({
          phone: this._phone,
          code_type: this._controller.query.code
        }, this._controller.query.params));
        this._controller.setTimer(time);
      } catch (error) {
        console.dir(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
          return;
        }
        this.$message.error(this.$t("verifyinput.unknown_error"));
      }
    });
  }
};
__decorateClass([
  PropSync("phone", { type: String, default: function() {
    return "";
  } })
], VerifyInput.prototype, "_phone", 2);
__decorateClass([
  PropSync("controller", { type: VerifyInputController, default: function() {
    return new VerifyInputController("", 0);
  } })
], VerifyInput.prototype, "_controller", 2);
VerifyInput = __decorateClass([
  Component
], VerifyInput);
export {
  VerifyInput as default
};
